export const TRANSACTION_DETAILS_DATA = {
  INITIAL_MIN_DATE: 30,
  MAX_RECORD_COUNT: 50,
  FIT_TO_SCREEN_NUM: 12,
  CLOSE_BTN: {
    TITLE: '',
    CLASS_NAME: 'absolute ml-[17rem] mt-[-1rem]',
    ICON: {
      CLASS_NAME: 'w-[0.625rem] h-[0.625rem]',
    },
  },
  TEXT_AREA: {
    CHAR_CAPACITY: 40,
    CLASS_NAME:
      'bg-bw02 text-bw07 text-base placeholder:text-bw06 font-metric w-full h-[7rem] pl-[1rem] pt-[1rem] pr-[3.5rem] py-[1.5rem] resize-none rounded-md outline-none',
    PLACE_HOLDER: 'TRANSACTION_DETAILS_ADD_NOTE',
    CONTAINER: {
      CLASS_NAME: 'w-full mt-4 h-[7rem]',
    },
  },
  CHAR_COUNTER: {
    CLASS_NAME: 'absolute right-3 top-4 text-right w-[2rem] text-xs text-bw06 font-metric box-border',
  },
  SAVE_BTN: {
    CLASS_NAME:
      'w-[3.5rem] absolute right-3 bottom-4 h-[1.438rem] text-bw00 rounded bg-action03 font-metric text-sm  flex gap-0.5 justify-center items-center hover:bg-action04',
  },
  TRX_TYPE: 'CHECK_DEPOSIT',
}as const;

export const NO_TRANSACTIONS = 'NO_MORE_TRANSACTIONS_TO_SHOW';

export const enum SORT_TYPES {
  ALPHABETICAL = 1,
  NUMERICAL,
  BY_DATE,
}

export const TRANSACTION_FILTER_TYPES = [
  {
    key: 'All Types',
    value: undefined,
  },
  {
    key: 'Purchase',
    value: 'PURCHASE',
  },
  {
    key: 'Money Transfer',
    value: 'FUND_TRANSFER',
  },
  {
    key: 'Refund',
    value: 'REFUND',
  },
  {
    key: 'Check Deposit',
    value: 'CHECK_DEPOSIT',
  },
  {
    key: 'ATM Withdrawal',
    value: 'ATM',
  },
];

export const TRANSACTIONS_TABLE_HEADERS = [
  {
    title: 'TRANSACTION_TABLE_COLUMN_HEADER_DATE',
    value: 'date',
    sortType: SORT_TYPES.BY_DATE,
    headerStyle: 'justify-start pb-4 pl-4',
    tdStyle: 'text-left text-xs font-normal text-bw07 pl-2',
  },
  {
    title: 'TRANSACTION_TABLE_COLUMN_HEADER_NAME',
    value: 'name',
    sortType: SORT_TYPES.ALPHABETICAL,
    headerStyle: 'justify-start pb-4 pl-1',
    tdStyle: 'text-left pl-1',
  },
  {
    title: 'TRANSACTION_TABLE_COLUMN_HEADER_STATUS',
    value: 'status',
    sortType: SORT_TYPES.ALPHABETICAL,
    headerStyle: 'justify-start pb-4 pl-2',
    tdStyle: 'text-center font-normal text-bw08 w-[135px] min-w-[135px]',
  },
  {
    title: 'TRANSACTION_TABLE_COLUMN_HEADER_AMOUNT',
    value: 'amount',
    sortType: SORT_TYPES.NUMERICAL,
    headerStyle: 'justify-end pb-4 pr-4',
    tdStyle: 'text-right pr-2',
  },
];

export const TABLE_STYLES = {
  TABLE_CONTAINER: 'relative bg-bw00 rounded-lg w-[744px] max-h-[504px] select-none',
  TABLE_HEADER: ' relative w-full rounded-lg grid grid-cols-table items-center px-[40px] pt-[40px] font-metricSemibold',
  TABLE_THEAD: 'sticky w-full top-0 bg-bw00',
  TABLE_BODY: 'w-full overflow-hidden h-[65.6vh] overflow-y-auto relative block',
  TABLE_HEADER_TITLE: ' hover:cursor-pointer flex gap-2',
  TABLE_ROW:
    'grid grid-cols-table rounded my-2 h-[48px] mx-[40px] p-2 cursor-pointer content-center items-center hover:bg-bw02 hover:rounded-xl',
  TABLE_ROW_ACTIVE:
    'grid grid-cols-table mx-[40px] my-2 h-[48px] cursor-pointer content-center items-center bg-bw02 rounded-xl px-2',
  TABLE_CELL: 'min-w-[100px] font-metricMedium overflow-hidden whitespace-nowrap text-ellipsis',
};

export const AMOUNT_CELL_NUMBER = 3;
export const STATUS_CELL_NUMBER = 2;

export const TRANSACTION_TAG = {
  CLASS_NAME: 'text-13px font-metric px-2 w-max h-[1.5rem] flex items-center mt-4 leading-[61px]',
  CATEGORY_CLASS_NAME: {
    WORK: 'text-action03 border border-action03 rounded-sm',
    LIFE: 'text-bw06 border border-bw06 rounded-sm',
  },
  DEFAULT_TAG_VALUE: 'oops, error',
};

export const VALID_CHIP_KEYS = ['type', 'amount', 'date'];

export const ENRICHMENT_TYPES = {
  MUST_ENRICH_TYPES: [
    'ACH_TRANSFER',
    'PAYMENT',
    'CHECK_DEPOSIT',
    'CHECK_DEPOSIT_BOUNCED',
    'CHECK_DEPOSIT_REJECTED',
    'DIRECT_DEPOSIT',
    'DIRECT_DEPOSIT_RETURN',
    'INCOMING_WIRE',
  ],
  NON_LOCATION_ENRICH_TYPES: ['SWIPE_REFUND', 'SWIPE_CASHBACK', 'SWIPE', 'STORE_WITHDRAWAL', 'ATM_WITHDRAWAL'],
};

export const TIMEOUT = 2000;
export const ERROR_MESSAGE = 'TEXT_AREA_ERROR_MESSAGE';
export const SUCCESS_MESSAGE = 'TEXT_AREA_SUCCESS_MESSAGE';

export const VERIFY = {
  TITLE: 'VERIFY_MESSAGE_TITLE',
  TEXT: 'VERIFY_MESSAGE_TEXT',
  ON_MOBILE: 'VERIFY_ON_MOBILE',
}as const;

export const TRANSACTION_DETAILS_TEXTS = {
  RECEIPT: 'TRANSACTION_DETAILS_RECEIPT',
  REPLACE_RECEIPT: 'TRANSACTION_DETAILS_RECEIPT_REPLACE',
  ACCOUNT_NUMBER: 'PROFILE_COMPONENT_ACCOUNT_NUMBER',
  ROUTING_NUMBER: 'PROFILE_COMPONENT_ROUTING_NUMBER',
  CHECK_NUMBER: 'TRANSACTION_DETAILS_CHECK_NUMBER',
  ARRIVAL_DATE: 'TRANSACTION_ESTIMATED_ARRIVAL_DATE',
} as const;

export const TRANSACTION_TYPES = {
  ACH_TRANSFER: 'ACH_TRANSFER',
  PAYMENT: 'PAYMENT',
  EMERGENCY_BUCKET: 'EMERGENCY_BUCKET',
  EMERGENCY_BUCKET_AUTO_SAVE: 'EMERGENCY_BUCKET_AUTO_SAVE',
  EMERGENCY_BUCKET_MANUAL_SAVE: 'EMERGENCY_BUCKET_MANUAL_SAVE',
  CASH_BACK: 'CASH_BACK',
  INTEREST: 'INTEREST',
  BILL_PAY: 'BILL_PAY',
  DIRECT_DEPOSIT_RETURN: 'DIRECT_DEPOSIT_RETURN',
  CASH_DEPOSIT: 'CASH_DEPOSIT',
  FEE: 'FEE',
  DEBIT_CARD_DEPOSIT: 'DEBIT_CARD_DEPOSIT',
  TAX_JAR: 'TAX_JAR',
  CAMPAIGN_GIFT: 'CAMPAIGN_GIFT',
  REFERRAL_GIFT: 'REFERRAL_GIFT',
  CHECK_DEPOSIT: 'CHECK_DEPOSIT',
  DIRECT_DEPOSIT: 'DIRECT_DEPOSIT',
  TRANSACTION_DETAILS_STATUS: {
    ACH: 'ACH',
    HOLD: 'HOLD',
    SETTLED: 'SETTLED',
    PENDING: 'PENDING',
    ON_HOLD: 'On Hold',
  },
  HOLD_REASON: {
    NAME_MISMATCH: 'NAME_MISMATCH',
  },
  EXTERNAL_TYPE: {
    CHECK_DEPOSIT_REJECTED: 'CHECK_DEPOSIT_REJECTED',
    CHECK_DEPOSIT_BOUNCED: 'CHECK_DEPOSIT_BOUNCED',
    CHECK_DEPOSIT_RETURN_ADJ: 'CHECK_DEPOSIT_RETURN_ADJ',
    EMERGENCY_BUCKET_MANUAL: 'EMERGENCY_BUCKET_MANUAL',
    EMERGENCY_BUCKET_AUTO: 'EMERGENCY_BUCKET_AUTO',
    SAVING_INTEREST: 'SAVING_INTEREST',
    CHECK_FEE: 'CHECK_FEE',
    PRO_FEE: 'PRO_FEE',
    TAX_JAR_MANUAL: 'TAX_JAR_MANUAL',
    TAX_JAR_AUTO: 'TAX_JAR_AUTO',
  },
  CHECK_STATUS: {
    SEND: 'SEND',
    ACCEPT: 'ACCEPT',
    APPROVED: 'APPROVED',
    REJECTED: 'Rejected',
    RETURNED: 'Returned',
    IN_REVIEW: 'In Review',
    IN_PROCESS: 'In Process',
  },
} as const;

export const TARGET_PROPERTIES = {
  COMMENT: 'comment',
  RECEIPT: 'receipt',
};
